import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import App from './App';
import { UI } from './components/UI';
import { Client } from './components/Client';
import { Error } from './components/Error';
import { WSProvider } from './provider/WS';
import { MetaHumanProvider }  from './components/MetaHumanComponent';
import { SpeechToTextProvider } from './components/SpeechToTextComponent';
const root = ReactDOM.createRoot(document.getElementById('root'));



root.render(
      <WSProvider>
        <MetaHumanProvider>
        <SpeechToTextProvider>
          <BrowserRouter>
            <Routes>
              <Route exact path="/" element={<App />}></Route>
              <Route exact path="/ui" element={<UI />}></Route>
              <Route exact path="/client" element={<Client />}></Route>
              <Route exact path="/error" element={<Error />}></Route>
            </Routes>
          </BrowserRouter>
          </SpeechToTextProvider>
          </MetaHumanProvider>
      </WSProvider>
);

